import { render, staticRenderFns } from "./InstructorRoles.vue?vue&type=template&id=27fd3326&scoped=true"
import script from "./InstructorRoles.vue?vue&type=script&lang=js"
export * from "./InstructorRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd3326",
  null
  
)

export default component.exports